var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinePoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 6.75,
  stroke: "#fff",
  strokeWidth: 1.125
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.75 12.75v-7.5h2.706q.832 0 1.395.322.567.322.857.886.291.561.292 1.275 0 .72-.292 1.282a2.13 2.13 0 0 1-.864.882q-.57.32-1.406.319H7.645V9.099h1.617q.486 0 .797-.176a1.1 1.1 0 0 0 .458-.483 1.6 1.6 0 0 0 .151-.707q0-.399-.151-.703a1.05 1.05 0 0 0-.462-.473q-.31-.172-.8-.172H8.057v6.365z"
})));
export default SvgLinePoint;